import type { JSX } from 'react';
import { useMemo } from 'react';
import type { Ev1Player } from 'types/e-v1-player-api-types';
import type { WistiaPlayer } from '@wistia/wistia-player';
import { PlayerPositionManager } from './PlayerPositionManager';

export type PlayerPositionManagerArgs<TPlayerParentContainer> = {
  bottomStyleWhenStickyAtBottomRight?: CSSStyleDeclaration['bottom'];
  leftStyleWhenStickyAtTop?: CSSStyleDeclaration['left'];
  player: Ev1Player | WistiaPlayer | null;
  playerParentContainer: TPlayerParentContainer | null;
  rightStyleWhenStickyAtBottomRight?: CSSStyleDeclaration['right'];
  rightStyleWhenStickyAtTop?: CSSStyleDeclaration['right'];
  topStyleWhenStickyAtTop?: CSSStyleDeclaration['top'];
  widthStyleWhenStickyAtBottomRight?: CSSStyleDeclaration['width'];
};

export const usePlayerPositionManager = <TPlayerParentContainer extends HTMLElement>({
  bottomStyleWhenStickyAtBottomRight,
  player,
  playerParentContainer,
  rightStyleWhenStickyAtBottomRight,
  widthStyleWhenStickyAtBottomRight,
  leftStyleWhenStickyAtTop,
  rightStyleWhenStickyAtTop,
  topStyleWhenStickyAtTop,
}: PlayerPositionManagerArgs<TPlayerParentContainer>): (() => JSX.Element) => {
  return useMemo(
    () => () => (
      <PlayerPositionManager
        bottomStyleWhenStickyAtBottomRight={bottomStyleWhenStickyAtBottomRight}
        leftStyleWhenStickyAtTop={leftStyleWhenStickyAtTop}
        player={player}
        playerParentContainer={playerParentContainer}
        rightStyleWhenStickyAtBottomRight={rightStyleWhenStickyAtBottomRight}
        rightStyleWhenStickyAtTop={rightStyleWhenStickyAtTop}
        topStyleWhenStickyAtTop={topStyleWhenStickyAtTop}
        widthStyleWhenStickyAtBottomRight={widthStyleWhenStickyAtBottomRight}
      />
    ),
    [
      bottomStyleWhenStickyAtBottomRight,
      leftStyleWhenStickyAtTop,
      player,
      playerParentContainer,
      rightStyleWhenStickyAtBottomRight,
      rightStyleWhenStickyAtTop,
      topStyleWhenStickyAtTop,
      widthStyleWhenStickyAtBottomRight,
    ],
  );
};
